import { memo } from "react";
import CustomerCallHistoryRow from "./CustomerCallHistoryRow";
import { Table } from "react-bootstrap";

const CustomerCallHistoryTable = ({ customerCalls }) => {
  return (
    <Table responsive striped bordered>
      <thead>
        <tr>
          <th>Sr No.</th>
          <th>Name</th>
          <th>Phone Number</th>
          <th>Status</th>
          <th>Call Time</th>
          <th>Sales Representative</th>
          <th>Details</th>
        </tr>
      </thead>
      <tbody>
        {customerCalls?.map((call, index) => (
          <CustomerCallHistoryRow call={call} key={call.id} index={index + 1} />
        ))}
      </tbody>
    </Table>
  );
};

export default memo(CustomerCallHistoryTable);
